// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"aca00abf","453":"149ccb08","718":"ba6efbec"}[chunkId] + ".chunk.js";
};